import { Box, Avatar, Typography, Badge } from '@mui/material';

type OfficialAvatarProps = {
  img_url?: string;
  name?: string;
  square?: boolean;
  officialTableView?: boolean;
  size?: 'small' | 'medium' | 'large';
  alt?: string;
};

export default function OfficialAvatar({
  img_url,
  name,
  square = false,
  officialTableView = false,
  size,
  alt
}: OfficialAvatarProps) {
  const sizes = {
    small: { width: 24, height: 24 },
    medium: { width: 32, height: 32 },
    large: { width: 72, height: 72}
  } as const;

  const sizeStyles = size ? sizes[size] : square ? sizes.medium : sizes.small

  const hasAlertBadge = !img_url && officialTableView;

  const avatar = (
    <Avatar
      sx={sizeStyles}
      src={img_url}
      alt={alt ?? "official avatar"}
      variant={square ? 'rounded' : 'circular'}
    />
  );

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, height: '100%' }}>
        {hasAlertBadge ? (
          <Badge
            color="error"
            variant="dot"
            anchorOrigin={{ vertical: 'bottom' }}
            data-testid="alert-badge"
            sx={{
              '& .MuiBadge-dot': {
                border: '2px solid white',
                width: 13,
                height: 13,
                borderRadius: '50%'
              }
            }}
          >
            {avatar}
          </Badge>
        ) : (
          avatar
        )}
        {name && (
          <Typography variant="body2" sx={{ marginLeft: 1 }}>
            {name}
          </Typography>
        )}
      </Box>
    </>
  );
}
